import { EMPTY_STRING } from "@/constants";

export const cropString = ({
  query,
  length = 20,
  step = 4,
  headFromIndex = 0,
}: {
  query: string;
  length?: number;
  step?: number;
  headFromIndex?: number;
}) => {
  if (!query) return EMPTY_STRING;

  if (query.length > length) {
    const head = query.substring(headFromIndex, step + 2);
    const tail = query.substring(query.length - step, query.length);

    return `${head}…${tail}`;
  }
  return query;
};

export const splitCamelCase = (word: string): string => {
  return word.replace(/([a-z])([A-Z])|([A-Z])([A-Z][a-z])/g, "$1$3 $2$4");
};

export const toCapitalized = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export const validateEmail = (input: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(input);
};

export const transformStringWithUpperHAPI = (words: string): string => {
  return words
    .split(/(?=[A-Z])/)
    .map((word) => {
      if (word.toLowerCase() === "hapi") {
        return word.toUpperCase();
      } else {
        return toCapitalized(word);
      }
    })
    .join(" ");
};

export const hexToBytes = (hex: string): Uint8Array => {
  if (hex.length % 2 !== 0) {
    throw new Error("Hex string must have an even length");
  }
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.slice(i, i + 2), 16);
  }
  return bytes;
};
